<template>
  <div class="mt-6 flex pb-3">
    <a-avatar
      :size="56"
      :src="src"
    />
    <div class="flex-1 ml-5 textarea">
      <a-textarea
        :rows="6"
        v-model="content"
      ></a-textarea>
      <a-button
        class="mt-2"
        :class="{'disabled': !content}"
        type="primary"
        @click="replyTheme"
      >提问</a-button>
      <a-popover
        v-model="visible"
        placement="bottomLeft"
        trigger="click"
        class="add-photo"
      >
        <template slot="content">
          <div class="add-content">
            <div class="d-flex justify-between">
              <span>图片（{{ num }}/9）</span>
              <span @click="close">
                <svg-icon
                  class="cp font-16"
                  iconClass="close"
                ></svg-icon>
              </span>
            </div>
            <div class="picture-up mt-3">
              <upload
                listType="picture-card"
                path="img/art/"
                @uploadChange="uploadChange"
                :limitNum="limitNum"
              ></upload>
            </div>
            <a-button
              class="mt-1"
              :class="{'disabled': !photos}"
              type="primary"
              @click="visible = false"
            >确定</a-button>
          </div>
        </template>
        <svg-icon
          style="font-size:16px"
          iconClass="photo"
        ></svg-icon>
      </a-popover>
    </div>
  </div>
</template>
<script>
import upload from '@/components/Upload'
export default {
  name: 'Question',
  props: {
    photo: {
      type: String,
      default: ''
    }
  },
  components: {
    upload
  },
  data () {
    return {
      content: '',
      photos: '',
      num: 0,
      limitNum: 9,
      visible: false,
    }
  },
  computed: {
    src () {
      const data = this.$store.getters.getUserData('headImgUrl')
      return data.headImgUrl
    },
  },
  methods: {
    uploadChange (ev) {
      this.num = ev.length
      this.photos = ev.join(',')
    },
    close () {
      // console.log(123)
      this.photos = ''
      this.visible = false
    },
    replyTheme () {
      this.visible = false
      this.$emit('submit', {
        content: this.content,
        photos: this.photos
      })
      this.content = ''
      this.photos = ''
    },
  },
}
</script>
<style lang='less' scoped>
.add-content {
  width: 264px;
  text-align: right;
}
.textarea {
  position: relative;
  text-align: right;
  .add-photo {
    position: absolute;
    left: 0px;
    bottom: 18px;
    // bottom: 46px;
  }
}
/deep/.ant-btn-primary {
  width: 84px;
  height: 32px;
  font-size: 14px;
  line-height: 32px;
}
.disabled {
  color: #fff;
  background: rgba(75, 125, 253, 0.5) !important;
  border: transparent;
}
</style>
<style>
.picture-up .ant-upload.ant-upload-select-picture-card {
  width: 80px;
  height: 80px;
}
.picture-up .ant-upload.ant-upload-select-picture-card {
  width: 80px;
  height: 80px;
}
.picture-up .ant-upload-list-picture-card .ant-upload-list-item {
  width: 80px;
  height: 80px;
}
.picture-up .ant-upload-list-picture-card-container {
  width: 80px;
  height: 80px;
}
</style>
